import { fetchWrapper } from "./fetchWrapper";
import { GingerMediaBaseUrl } from "./baseUrls";

export async function removeImageUrlFromMediaData(service: string, gmgAssetCode: string) {
    return fetchWrapper(`${GingerMediaBaseUrl}/removeImageUrlFromMediaData?serviceId=${service}&gmgAssetCode=${gmgAssetCode}`, {
        method: 'POST'
    });
}